import React from 'react'

const SvgComplex = (props: any) => (
  <svg width={32} height={32} {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M4 4h24v24H4z" />
      <path
        d="M25 25H7a1 1 0 01-1-1v-7.513a1 1 0 01.343-.754L10 12.544V8a1 1 0 011-1h14a1 1 0 011 1v16a1 1 0 01-1 1zm-12-2h3v-6.058l-4-3.488-4 3.488V23h3v-4h2v4zm5 0h6V9H12v2.127c.234 0 .469.082.657.247l5 4.359a1 1 0 01.343.754V23zm2-8h2v2h-2v-2zm0 4h2v2h-2v-2zm0-8h2v2h-2v-2zm-4 0h2v2h-2v-2z"
        fillOpacity={0.64}
        fill="#191923"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComplex
